
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { timeout } from 'rxjs/operators/timeout';
import { map } from 'rxjs/operators/map';
import { catchError } from 'rxjs/operators/catchError';
import { Observable, throwError } from 'rxjs';

@Injectable()
export class UtilServiceV2 {
  headers: any;
  options: any;
  timeoutMiliSeconds: any = 3600000;
  // usuarioLogado: any;

  //LOCAL 
  //public urlBase = "http://localhost:8081/";
 
  //HOMOLOGACAO => 
  // public urlBase  = "https://reports-agora-staging.tce.ce.gov.br/";

  // PRODUCAO => 
  public urlBase  = "https://reports-agora.tce.ce.gov.br/";


  constructor(
    public http: HttpClient) {
    this.headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    this.options = { headers: this.headers };
  }

  public getOptions() {
    let headers: HttpHeaders;
    headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return { headers: headers };
  }

  private handleError(error: any) {    
    if (error.error) {
      let errMsg =
        error.error.mensagem ? { mensagem : error.error.mensagem } :
          error.error.listaErros ? { inconsistencias : error.error.listaErros } :
            error.name == "TimeoutError" || error.url == null ? { mensagem : "Não foi possível acessar o servidor." } :
              error.status ? { mensagem : JSON.parse(error._body) } :
                (error.message) ? { mensagem : error.message } :
                  { mensagem : "Erro desconhecido." };

      return throwError(errMsg);
    }
  }

  private handleSucess(sucess: any) {
    return sucess;
  }

  public getJSON(urlObtencaoDados: string): Observable<any> {
    let options = this.getOptions();
    return this.http.get(this.urlBase + urlObtencaoDados, options)
      .pipe(timeout(this.timeoutMiliSeconds), map(res => res), catchError(error => this.handleError(error)));
  }

}


// WEBPACK FOOTER //
// ./src/providers/util-service-v2.ts